module.exports = __webpack_public_path__ + "img/MGH-Gaien-11.4f8fbea2.jpg";